import FixFlip from "./FixFlip";

export default FixFlip;